// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vs7H","colMin":"styles_colMin__1iRlm"};